import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import CommonComponents from "./components/js/common-components";

// 注册所有的图标
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 国际化配置
import zhCn from "element-plus/dist/locale/zh-cn.mjs";

/* 重置样式 */
import "./assets/css/reset.min.css";

/* jquery */
import jQuery from "jquery";

/* bootstarp */
import "./assets/css/bootstrap.min.css";
// import "./assets/js/bootstrap.min";

// Magic.css
// import "./assets/css/magic.css";
import "./assets/css/app.css";
import "./assets/css/font.css";

/* animate.css */
// import "animate.css";
import "@/assets/css/myAnimate.css";




const app = createApp(App);


app.config.globalProperties.$ = jQuery;

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

// app.directive("wow", {
//   mounted(el) {
//     var wow = new Wow.WOW()({
//         boxClass: 'wow',///动画元件css类（默认为wow）
//         animateClass: 'animated',//动画css类（默认为animated） 
//         offset: 0,//到元素距离触发动画（当默认为0） 
//         mobile: true, //在移动设备上触发动画（默认为true） 
//         live: true//对异步加载的内容进行操作（默认为true）
//        })
//     wow.init();
//   },
// });
// app.use(VueAwesomeSwiper);
app.use(ElementPlus, {
    locale: zhCn,
})
app.use(CommonComponents); // 全局引用公共组件
app.use(store).use(router).mount("#app");

